import { useEffect, useState } from "react"
import JobSiteFormModal from "../../components/construction/JobSiteFormModal"
import CwDataTable from "../../components/construction/CwDataTable"
import CwPageHeader from "../../components/construction/CwPageHeader"
import CwAddButton from "../../components/construction/CwAddButton"
import CwRowActions from "../../components/construction/CwRowActions"
import { SageJobSite } from "../../Interfaces"
import { t } from "../../i18n"
import { displayJobSiteCode } from "../../utils/sageCodes"

const seed: SageJobSite[] = [
  {
    id: 501,
    sageRecnum: "c12:2017008",
    name: "Riverside Office Complex",
    shortName: "2017008",
    jobNumber: "2017008",
    address: "1200 River Road",
    city: "Austin",
    state: "TX",
    zip: "78701",
    supervisor: "Mike Thompson",
    status: 1,
    sample: false,
  },
]

/**
 * Unauthenticated fixture for ConstructionWalk job sites.
 * /preview/job-sites?product=construction
 */
export default function JobSitesPreview() {
  const params = new URLSearchParams(window.location.search)
  const [open, setOpen] = useState(params.get("modal") === "1" || params.get("edit") === "1")
  const [editing, setEditing] = useState<SageJobSite | null>(params.get("edit") === "1" ? seed[0] : null)

  useEffect(() => {
    document.documentElement.classList.add("construction-walk")
  }, [])

  return (
    <div className="min-h-screen p-4 md:p-8 bg-secondary-extra-light">
      <CwPageHeader
        title={t("jobSites.title")}
        subtitle="Valley Builders · VAL"
        action={<CwAddButton label={t("jobSites.add")} onClick={() => { setEditing(null); setOpen(true) }} />}
      />
      <CwDataTable
        columns={[
          { key: "name", label: t("jobSites.columnName") },
          { key: "code", label: t("jobSites.columnCode"), render: (row) => displayJobSiteCode(row) },
          {
            key: "actions",
            label: t("common.actions"),
            render: (row) => (
              <CwRowActions
                onEdit={() => {
                  setEditing(row)
                  setOpen(true)
                }}
                onDelete={() => undefined}
              />
            ),
          },
        ]}
        rows={seed}
      />
      <JobSiteFormModal
        isOpen={open}
        companyId={12}
        jobSite={editing}
        onClose={() => {
          setOpen(false)
          setEditing(null)
        }}
        onSaved={() => {
          setOpen(false)
          setEditing(null)
        }}
      />
    </div>
  )
}
